import React, { useState } from "react";
import PropTypes from "prop-types";
import "./InfoSection.css";
import restaurantImage from "../assets/image1.jpeg";

const InfoSection = ({ restaurant }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleAdditionalInfo = () => {
    setIsExpanded(!isExpanded);
  };

  const {
    name = "Restauracja",
    image = restaurantImage,
    address = "Adres",
    addressLink = "#",
    phone = "Telefon",
    phoneLink = "#",
    hoursDetail = "7:00 - 00:00",
    details = [],
  } = restaurant || {};

  return (
    <div className="info-section">
      <div className="restaurant-image-container">
        <div className="image-overlay">
          <img
            src={image}
            alt={name}
            className="restaurant-image"
          />
          <div className="image-text">
            <h1>{name}</h1>
          </div>
        </div>
      </div>
      <h2>Informacje o restauracji</h2>
      <div className="info-grid">
        <div className="paper">
          <h3>Adres</h3>
          <p>
            <a
              href={addressLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Nawiguj na Big Mac!
            </a>
          </p>
          <p>{address}</p>
        </div>
        <div className="paper">
          <h3>Telefon</h3>
          <p>
            <a href={phoneLink}>Zadzwoń</a>
          </p>
          <p>{phone}</p>
        </div>
        <div className="paper">
          <h3>Godziny Otwarcia</h3>
          <h4>Pon - Nd: </h4>
          <p>{hoursDetail}</p>
        </div>
      </div>
      <div className={`additional-info ${isExpanded ? "expanded" : ""}`}>
        <button className="toggle-button" onClick={toggleAdditionalInfo}>
          {isExpanded ? "mniej..." : "więcej?"}
        </button>
        <div className="additional-content">
          <h3>Dodatkowe informacje</h3>
          <ul>
            {details.map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

InfoSection.propTypes = {
  restaurant: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
    address: PropTypes.string,
    addressLink: PropTypes.string,
    phone: PropTypes.string,
    phoneLink: PropTypes.string,
    hoursDetail: PropTypes.string,
    details: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default InfoSection;
